import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlugAndPlayDragModel, PlugAndPlayModel } from '../models/plugAndPlay.model';
import { InfraService } from './infra.service';


@Injectable()
export class PlugAndPlayService {

    private configUrl: string;
    private apiCoreUrl: string;
        
    constructor(private infraService: InfraService, private http: HttpClient) {
        this.infraService.infraDetails$.subscribe(data => {
            this.configUrl = data.WebEndPoint1 + 'plugandplay';
            this.apiCoreUrl = data.WebEndPoint2 + 'plugandplay/';;        
        });
    }

    public getPlugAndPlayByEngagementId(engagemnentId: string): Observable<PlugAndPlayModel[]> {       

        return this.http.get<PlugAndPlayModel[]>(`${this.apiCoreUrl}GetPlugAndPlayDetails/${engagemnentId}`);
    }

    public getPlugAndPlayPLByEngagementId(engagemnentId: string): Observable<PlugAndPlayModel[]> {
      
        return this.http.get<PlugAndPlayModel[]>(`${this.apiCoreUrl}GetPlugAndPlayDetails/${engagemnentId}/PL`);
    }

    public getPlugAndPlayBSByEngagementId(engagemnentId: string): Observable<PlugAndPlayModel[]> {      

        return this.http.get<PlugAndPlayModel[]>(`${this.apiCoreUrl}GetPlugAndPlayDetails/${engagemnentId}/BS`);
    }

    public save(plugAndPlayData: PlugAndPlayModel) {
        return this.http.post(`${this.apiCoreUrl}CreatePlugAndPlay`, plugAndPlayData);
      }

    public saveSubTotal(plugAndPlayData: PlugAndPlayModel) {
    return this.http.post(`${this.apiCoreUrl}CreatePlugAndPlaySubTotal`, plugAndPlayData);
    }

    public saveStandardMappingWithSubTotal(plugAndPlayDragModel: PlugAndPlayDragModel) {
        return this.http.post(`${this.apiCoreUrl}SaveStandardMappingWithSubTotal`, plugAndPlayDragModel);
    }

    public saveAllData(plugAndPlayData: PlugAndPlayModel[], smIds : number[], regionId : number) {
      return this.http.post(`${this.apiCoreUrl}SaveAllPlugAndPlayDetails`, { 'PlugAndPlayData': plugAndPlayData, 'SMIds': smIds,'RegionId' : regionId });
    }

    public resetAllMappingDetails(engagementId: number, regionId : number) {
            return this.http.post(`${this.apiCoreUrl}ResetAllPlugAndPlayDetails/${engagementId}/${regionId}`, {});
    }

    public getBalanceSheetGroup(engagemnentId: number): Observable<string[]> {  
        return this.http.get<string[]>(`${this.apiCoreUrl}GetBalanceSheetGroup/${engagemnentId}`);
    }

    public getLayoutNamesByTemplateId(userId: number, templateId:number, languageId:number): Observable<string[]> {  
        return this.http.get<string[]>(`${this.apiCoreUrl}GetLayoutNamesByTemplateId/${userId}/${templateId}/${languageId}`);
    }

}
